import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

function ContactSales() {
    const navigate = useNavigate();

    return (
        <>
            <div id="contactsales">
                <div className="py-5 col-md-5 m-auto  ">
                    <div className='shadow rounded rounded-3 p-4'>
                        <h3>Book a Demo</h3>
                        <form>
                            <div className='mb-3'>
                                <label>Email Address</label>
                                <input type="email" className="form-control" />
                            </div>
                            <div className='mb-3'>
                                <label>First Name</label>
                                <input type="text" className="form-control" />
                            </div>
                            <div className='mb-3'>
                                <label>Last Name</label>
                                <input type="text" className="form-control" />
                            </div>

                            <div className='mb-3'>
                                <label>Country</label>
                                <select className='form-select'>

                                </select>
                            </div>

                            <div className='mb-3'>
                                <button className="btn btn-primary">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ContactSales
